import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData } from "@/js/forms.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { paging, defaultPagingChoices, emptyCellContent, bottlings } from "@/js/lists.ts";
import ImportSupplierPrices from "@/components/supplier-prices/ImportSupplierPrices.vue";
import ScriptWithSupplierPricesModal from "@/components/supplier-prices/ScriptWithSupplierPricesModal.vue";
import Paging from "@/components/paging/PagingComponent.vue";
import Index from "@/components/paging/IndexComponent.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import NewWineDialog from "@/components/products/NewWineDialog.vue";
import AssociateWineModal from "@/components/products/AssociateWine/AssociateWineModal.vue";
import SupplierListModal from "@/components/supplier-prices/SupplierListModal.vue";
export default {
  name: "SupplierPricesList",
  components: {
    ImportSupplierPrices: ImportSupplierPrices,
    ScriptWithSupplierPricesModal: ScriptWithSupplierPricesModal,
    NewWineDialog: NewWineDialog,
    AssociateWineModal: AssociateWineModal,
    SupplierListModal: SupplierListModal,
    Paging: Paging,
    Index: Index,
    Confirm: Confirm
  },
  data: function data() {
    return {
      isImportSupplierPricesShown: false,
      isScriptsWithSupplierPricesShown: false,
      fetchSuppliersPricesToken: null,
      fetchSuppliersToken: null,
      fetchWineSupplierFiltersToken: null,
      updateWineSupplierPriceToken: null,
      formSearch: {
        label: null,
        wineId: null,
        suppliersIds: [],
        vintages: [],
        bottlings: [],
        onlyWithWineId: false,
        onlyWithoutWineId: false,
        selectedStatus: null,
        paging: {
          limits: paging.DEFAULT,
          currentPage: 0,
          askedPage: 0
        }
      },
      datatable_headers: [{
        text: "Status",
        value: "status",
        align: "center"
      }, {
        text: "Description",
        value: "name",
        align: "left"
      }, {
        text: "Bottling",
        value: "bottling",
        align: "center"
      }, {
        text: "Vintage",
        value: "vintage",
        align: "center"
      }, {
        text: "Supplier",
        value: "supplier.name",
        align: "center"
      }, {
        text: "Supplier Cogs",
        value: "price",
        align: "center"
      }, {
        text: "Creation",
        value: "createdAt",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "left"
      }],
      pagingLimitsChoices: defaultPagingChoices,
      isLoadingList: true,
      datatable_items: [],
      totalNumber: null,
      numberOfPages: null,
      suppliers: [],
      vintages: [],
      searchLabelLastUsed: null,
      searchSuppliersIdsLastUsed: [],
      searchVintagesLastUsed: [],
      searchBottlingsLastUsed: [],
      searchStatusLastUsed: [],
      status: {
        options: [{
          id: 1,
          name: "Not linked to wine"
        }, {
          id: 2,
          name: "Linked to wine"
        }]
      },
      createWineModal: {
        isVisible: false,
        selectedSupplierPrice: {}
      },
      associateWine: {
        selectedSupplierPrice: {}
      },
      wineIdForCloning: null,
      emptyCellContent: emptyCellContent,
      bottlings: bottlings
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.isLoadingList && this.datatable_items.length > 0;
    }
  },
  watch: {
    "formSearch.selectedStatus": function formSearchSelectedStatus(newVal, oldVal) {
      this.formSearch.onlyWithWineId = newVal == 2;
      this.formSearch.onlyWithoutWineId = newVal == 1;
    }
  },
  created: function created() {
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.supplierPrices) {
      this.formSearch = _objectSpread({}, filters.supplierPrices);
    }
    this.fetchWineSupplierFilters();
    this.fetchSuppliers(true);
    this.search();
  },
  props: {
    loggedUserData: Object
  },
  methods: {
    importSupplierPrices: function importSupplierPrices() {
      this.isImportSupplierPricesShown = true;
    },
    openScriptsWithSupplierPrices: function openScriptsWithSupplierPrices() {
      var _this2 = this;
      this.isScriptsWithSupplierPricesShown = true;
      this.$nextTick(function () {
        _this2.$refs.refScriptWithSupplierPricesModal.open();
      });
    },
    search: function search() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3$fetchSuppliers;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.isLoadingList = true;
              (_this3$fetchSuppliers = _this3.fetchSuppliersPricesToken) === null || _this3$fetchSuppliers === void 0 || _this3$fetchSuppliers.cancel();
              _this3.fetchSuppliersPricesToken = axios.CancelToken.source();
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  supplierPrices: _this3.formSearch
                });
              });
              _this3.searchSuppliersIdsLastUsed = _this3.formSearch.suppliersIds;
              _this3.searchLabelLastUsed = _this3.formSearch.label;
              _this3.searchVintagesLastUsed = _this3.formSearch.vintages;
              _this3.searchBottlingsLastUsed = _this3.formSearch.bottlings;
              _this3.searchStatusLastUsed = _this3.formSearch.selectedStatus;
              data = _objectSpread(_objectSpread({}, _this3.formSearch), {}, {
                suppliers: _this3.formSearch.suppliersIds
              });
              _this = _this3;
              _context.next = 13;
              return request("/v1/wine/supplier-prices", "post", data, true, "api", null, _this3.fetchSuppliersPricesToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load suppliers prices.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 13:
              response = _context.sent;
              if (response) {
                _this3.totalNumber = response.data.value.total_number;
                _this3.numberOfPages = Math.ceil(response.data.value.total_number / +_this3.formSearch.paging.limits);
                _this3.formSearch.paging.currentPage = _this3.formSearch.paging.askedPage + 1;
                _this3.datatable_items = response.data.value.items;
                _this3.setSuppliersPricesStatus();
              }
              _this3.isLoadingList = false;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setSuppliersPricesStatus: function setSuppliersPricesStatus() {
      this.datatable_items = this.datatable_items.map(function (x) {
        var status = 0;
        var statusLabel = "";
        if (x.wineId) {
          status = 1;
          statusLabel = "success";
        } else {
          status = 2;
          statusLabel = "warning";
        }
        return _objectSpread(_objectSpread({}, x), {}, {
          status: status,
          statusLabel: statusLabel
        });
      });
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
        window.scrollTo(0, 0);
      }
    },
    toProductDetails: function toProductDetails(item) {
      var query = {};
      return {
        name: "adminWineDetails",
        query: query,
        params: {
          id: item.wineId
        }
      };
    },
    fetchSuppliers: function fetchSuppliers() {
      var _arguments = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$fetchSuppliers;
        var init, _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              init = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              (_this4$fetchSuppliers = _this4.fetchSuppliersToken) === null || _this4$fetchSuppliers === void 0 || _this4$fetchSuppliers.cancel();
              _this4.fetchSuppliersToken = axios.CancelToken.source();
              _this = _this4;
              _context2.next = 6;
              return request("/v1/suppliers", "get", null, true, "api", null, _this4.fetchSuppliersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load suppliers.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              response = _context2.sent;
              if (response) {
                _this4.suppliers = response.data.value.map(function (supplier) {
                  return _objectSpread(_objectSpread({}, supplier), {}, {
                    display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")")
                  });
                });
                if (init && _this4.supplierId) {
                  _this4.formAdd.supplierId = _this4.supplierId;
                }
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWineSupplierFilters: function fetchWineSupplierFilters() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$fetchWineSuppl;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              (_this5$fetchWineSuppl = _this5.fetchWineSupplierFiltersToken) === null || _this5$fetchWineSuppl === void 0 || _this5$fetchWineSuppl.cancel();
              _this5.fetchWineSupplierFiltersToken = axios.CancelToken.source();
              _this = _this5;
              _context3.next = 5;
              return request("/v1/wine/supplier-price-filters", "get", null, true, "api", null, _this5.fetchWineSupplierFiltersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the supplier filters.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  return;
                }
              });
            case 5:
              response = _context3.sent;
              if (response) {
                _this5.vintages = response.data.value.vintages;
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openCreateWineDialog: function openCreateWineDialog(supplierPrice) {
      this.createWineModal.selectedSupplierPrice = _objectSpread(_objectSpread({}, supplierPrice), {}, {
        wineSupplierPriceId: supplierPrice.id,
        description: supplierPrice.name
      });
      this.createWineModal.isVisible = true;
    },
    closeCreateWineDialog: function closeCreateWineDialog() {
      this.createWineModal.isVisible = false;
    },
    createWineSavedDialog: function createWineSavedDialog(response) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.updateWineSupplierPrice(response);
            case 2:
              _this6.search();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openAssociateWineModal: function openAssociateWineModal(supplierPrice) {
      this.$refs.associateWineModal.open();
      this.associateWine.selectedSupplierPrice = _objectSpread(_objectSpread({}, supplierPrice), {}, {
        wineSupplierPriceId: supplierPrice.id,
        description: supplierPrice.name
      });
    },
    associateWineToSupplierPrice: function associateWineToSupplierPrice(wineId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.updateWineSupplierPrice({
                wineSupplierPriceId: _this7.associateWine.selectedSupplierPrice.wineSupplierPriceId,
                wineId: wineId
              });
            case 2:
              _this7.search();
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    associateCloneWine: function associateCloneWine(wineId) {
      this.wineIdForCloning = wineId;
      this.openCreateWineDialog(this.associateWine.selectedSupplierPrice);
    },
    updateWineSupplierPrice: function updateWineSupplierPrice(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this8$updateWineSupp;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              (_this8$updateWineSupp = _this8.updateWineSupplierPriceToken) === null || _this8$updateWineSupp === void 0 || _this8$updateWineSupp.cancel();
              _this8.updateWineSupplierPriceToken = axios.CancelToken.source();
              data = {
                wineId: item.wineId
              };
              _this = _this8;
              _context6.next = 6;
              return request("/v1/suppliers/wine-price/".concat(item.wineSupplierPriceId), "put", data, true, "api", null, _this8.updateWineSupplierPriceToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to attach wine to supplier price line.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              _this8.closeCreateWineDialog();
              _this8.$toasted.show("Wine attached to supplier price line.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openDeletePrices: function openDeletePrices() {
      this.$refs.SupplierListModal.open();
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};